<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Edición ítem</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Edición ítem</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="pvItemForm">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.NroLinea}}</mat-label>

                        <input readonly formControlName="nroLinea" type="text" matInput>
                    </mat-form-field>
                </div>


                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{etiquetaStockDisponible}}</mat-label>
                        <input readonly [value]=" cantidadDisponible.value | number : '1.2-2'" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Cantidad}}</mat-label>
                        <input appThreeDigitDecimaNumber formControlName="cantidad" type="text" matInput>
                        <mat-error
                            *ngIf=" !pvItemForm.controls['cantidad'].valid && pvItemForm.get('cantidad').touched">
                            {{Validaciones.Cantidad}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3"
                *ngIf="avisoUnidadesPallet">

                <mat-card class="mat-card-error animate__animated animate__zoomIn animate__faster">

                    <mat-card-content>

                        <p>{{this.mensajeUnidadesPallet}} </p>

                    </mat-card-content>

                </mat-card>
            </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdProducto}}</mat-label>
                        <input readonly formControlName="idProducto" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.Producto}}</mat-label>
                        <input readonly formControlName="producto" type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioUnitarioLista}}</mat-label>
                        <input readonly [value]="pvItemForm.controls['precioUnitarioLista'].value | number : '1.2-2'"
                            type="text" matInput>

                    </mat-form-field>
                </div>

   

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioUnitarioFinal}}</mat-label>
                        <input readonly
                            [value]="pvItemForm.controls['precioUnitarioFinal'].value | number:'1.2-2':'es-AR'"
                            type="text" matInput>

                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field [hidden]="!pvCab.preciosFijos" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioFinal}}</mat-label>
                        <input appTwoDigitDecimaNumber (blur)="checkPrecioFinal()" formControlName="precioFinal"
                            type="text" matInput>

                        <mat-error
                            *ngIf="!pvItemForm.controls['precioFinal'].valid && pvItemForm.get('precioFinal').touched">
                            {{Validaciones.PrecioFinal}}
                        </mat-error>

                    </mat-form-field>
                </div>

                <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field [ngClass]="pvCab != null && pvCab.preciosFijos ? '' : 'readonly-form-field'"
                        color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.PrecioFinal}}</mat-label>
                        <input appTwoDigitDecimaNumber (blur)="checkPrecioFinal()"
                            [hidden]="pvCab == null || (pvCab != null && !pvCab.preciosFijos)"
                            formControlName="precioFinal" type="text" matInput>
                        <input readonly [hidden]="pvCab == null || (pvCab != null && pvCab.preciosFijos)" [value]=""
                            type="text" matInput>

                        <mat-error
                            *ngIf="!pvItemForm.controls['precioFinal'].valid && pvItemForm.get('precioFinal').touched">
                            {{Validaciones.PrecioFinal}}
                        </mat-error>

                    </mat-form-field>
                </div> -->




            </div>
        </div>




    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardarItem()" [disabled]="pvItemForm.invalid" mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>